export default __webpack_public_path__ + "static/media/SB Logo Login 290x80.bd4ffc45.svg";